module.exports = __webpack_public_path__ + "img/bluedownarrow.6966b2a6.svg";